import { render, staticRenderFns } from "./ProjectCustomTab.vue?vue&type=template&id=14e4902c&"
import script from "./ProjectCustomTab.vue?vue&type=script&lang=ts&"
export * from "./ProjectCustomTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports